import { IonCol } from "@ionic/react";
import { FormattedMessage } from "react-intl";

import styles from "@components/ResourceFeatures.module.css";
import BodyCopy from "@components/typography/BodyCopy";
import useSanitizeHtml from "@hooks/useSanitizeHtml";
import { ResourceFeatureKindEnum, ResourceFragment } from "@typing/Generated";

type Props = {
  journeyId: string;
  resource: ResourceFragment;
  resourceFeature: ResourceFragment["task"]["resourceFeatures"][number];
  resourceFeatureValue?: ResourceFragment["featureValues"][number];
};

const ResourceFeature = ({ journeyId, resource, resourceFeature, resourceFeatureValue }: Props) => {
  const sanitizedBody = useSanitizeHtml({ journeyId, rawHtml: resourceFeatureValue?.textValue, resource });

  return (
    <IonCol className={styles.featureValue} key={resourceFeature.id} size="12 ">
      <div className={styles.featureName}>
        <BodyCopy bold>{resourceFeature.name}</BodyCopy>
      </div>
      <div>
        <BodyCopy>
          {resourceFeature.kind === ResourceFeatureKindEnum.BOOLEAN ? (
            <>
              {typeof resourceFeatureValue?.booleanValue === "boolean" && (
                <FormattedMessage id={`dictionary.${resourceFeatureValue.booleanValue ? "yes" : "no"}`} />
              )}
            </>
          ) : (
            sanitizedBody
          )}
        </BodyCopy>
      </div>
    </IonCol>
  );
};

export default ResourceFeature;
